import formStyle from '../../../styles/modules/form.module.scss';
import styles from './FormValue.module.scss';

type Props = {
  children: React.ReactNode;
  label: string;
};

function FormValue({ children, label }: Props) {
  // variantに応じてクラス名を決定
  const labelStyle = styles.label;
  const fieldWrapperStyle = styles.fieldWrapper;

  return (
    <div className={formStyle.formComponentStyle}>
      {/* ラベル */}
      {label && <div className={labelStyle}>{label}</div>}
      {/* フィールド */}
      <div className={fieldWrapperStyle}>{children}</div>
    </div>
  );
}

export default FormValue;
